/**
 * Task durations are STORED in minutes (scheduled_tasks.estimated_duration_mins)
 * - the calendar's block heights, the task pages and the API all read minutes -
 * but people plan visits in hours, so the forms ask for hours (Gareth
 * 2026-09-21) and convert on the way in and out.
 *
 * Two decimal places of an hour is within 0.3 of a minute, so any whole number
 * of minutes already stored (50, 35, 20...) survives a load-and-save unchanged.
 */

/** Minutes as stored -> the hours shown in a form field ('' when there is none). */
export function minutesToHours(minutes) {
  const value = Number(minutes);
  if (minutes === null || minutes === undefined || minutes === '' || !Number.isFinite(value) || value <= 0) return '';
  return String(Math.round((value / 60) * 100) / 100);
}

/** Hours as typed -> whole minutes to store (null when blank or not a positive number). */
export function hoursToMinutes(hours) {
  const value = Number(hours);
  if (hours === null || hours === undefined || hours === '' || !Number.isFinite(value) || value <= 0) return null;
  return Math.round(value * 60);
}

/** Minutes as stored -> '45 min', '2 hr', '1 hr 30 min' ('-' when there is none). */
export function formatDuration(minutes) {
  const value = Number(minutes);
  if (!Number.isFinite(value) || value <= 0) return '-';
  const hours = Math.floor(value / 60);
  const rest = Math.round(value % 60);
  if (hours === 0) return `${rest} min`;
  if (rest === 0) return `${hours} hr`;
  return `${hours} hr ${rest} min`;
}
